import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { DealershipHolidaysComponent } from './dealership-holidays.component';


const routes: Routes = [
    {
        path: '',
        component: DealershipHolidaysComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DealershipHolidaysRoutingModule { }
